import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { PageShell } from "./components/PageShell";
import { SessionProvider } from "./state/SessionProvider";
import { HomePage } from "./pages/HomePage";
import { HelpPage } from "./pages/HelpPage";
import { ConcernPage } from "./pages/ConcernPage";
import { HospitalityPage } from "./pages/HospitalityPage";
import { ResourcesPage } from "./pages/ResourcesPage";
import { PrivacyPage } from "./pages/PrivacyPage";
import { ExitPage } from "./pages/ExitPage";
import { QrEntryPage } from "./pages/QrEntryPage";

export function App() {
  return (
    <SessionProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<PageShell />}>
            <Route index element={<HomePage />} />
            <Route path="help" element={<HelpPage />} />
            <Route path="concern" element={<ConcernPage />} />
            <Route path="pro/hospitality" element={<HospitalityPage />} />
            <Route path="resources" element={<ResourcesPage />} />
            <Route path="privacy" element={<PrivacyPage />} />
            <Route path="exit" element={<ExitPage />} />
            <Route path="q/:code" element={<QrEntryPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </SessionProvider>
  );
}
